// Components
import DatePicker from 'vue2-datepicker';
const ModalCustomRecipients = () => import(/*webpackPrefetch: true, webpackChunkName: "modal-custom-recipients"*/ '@/app/views/main-view/notifications/containers/modals/modal-custom-recipients/modal-custom-recipients.vue');
const ModalNotificationBody = () => import(/* webpackPrefetch: true, webpackChunkName: "modal-notification-body" */ '@/app/views/main-view/notifications/containers/modals/modal-notification-body/modal-notification-body.vue');

// Mixins
import { tableMixins } from '@/app/mixins/utils/table-mixins';
import { dateMixins } from '@/app/mixins/utils/date-mixins';
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins.js';

// Services
import NotificationService from '@/app/services/main/notifications/notifications-service';

// Constants
import { STATUS_CODES } from '@/app/constants/constants';

export default {
	name: 'NotificationContainer',
	components: {
		DatePicker,
		ModalCustomRecipients,
		ModalNotificationBody
	},
	mixins: [
		tableMixins,
		dateMixins,
		toastMessageMixins
	],
	data() {
		return {
			isAPILoading: false,
			selectedDateTime: '',
			// table
			theads: [
				{ name: 'Notification Image', searchLabel: null, sortLabel: null, isDesc: false, hasSearch: false, style: 'max-width: 110px; white-space: break-spaces;'},
				{ name: 'Notification Title', searchLabel: 'f_title', sortLabel: 'title', isDesc: false, hasSearch: true, style: null},
				{ name: 'Notification Link', searchLabel: 'f_link', sortLabel: 'link', isDesc: false, hasSearch: true, style: null},
				{ name: 'Scheduled Type', searchLabel: 'f_scheduleType', isDesc: false, style: null, hasScheduleTypeList: true},
				{ name: 'Scheduled Date', searchLabel: 'f_schedule', sortLabel: 'schedule', isDesc: false, style: null, hasDatePicker: true},
				{ name: 'Recipients', searchLabel: null, sortLabel: null, isDesc: false, style: 'min-width: 120px'},
				{ name: null, searchLabel: null, sortLabel: null, isDesc: false, style: null},
				{ name: null, searchLabel: null, sortLabel: null, isDesc: false, hasSearch: false,  style: null},
				{ name: null, searchLabel: null, sortLabel: null, isDesc: false, style: null}
			],
			// sorting
			desc: true,
			scheduleTypeList: [
				{
					name: `Date Base`,
					id: `1`,
					value: `DATE_BASE`
				},
				{
					name: `Age Base`,
					id: `2`,
					value: `AGE_BASE`
				}
			],
			selectedScheduleType: `DATE_BASE`
		}
	},
	watch: {
		selectedDateTime() {
			this.getTableContent(true);
		},
		selectedScheduleType(newVal) {
			if (newVal === `DATE_BASE`) {
				this.selectedDateTime = ``;
				this.theads = [
					{ name: 'Notification Image', searchLabel: null, sortLabel: null, isDesc: false, hasSearch: false, style: null},
					{ name: 'Notification Title', searchLabel: 'f_title', sortLabel: 'title', isDesc: false, hasSearch: true, style: null},
					{ name: 'Notification Link', searchLabel: 'f_link', sortLabel: 'link', isDesc: false, hasSearch: true, style: null},
					{ name: 'Scheduled Type', searchLabel: 'f_scheduleType', isDesc: false, style: null, hasScheduleTypeList: true},
					{ name: 'Scheduled Date', searchLabel: 'f_schedule', sortLabel: 'schedule', isDesc: false, style: null, hasDatePicker: true},
					{ name: 'Recipients', searchLabel: null, sortLabel: null, isDesc: false, style: 'min-width: 120px'},
					{ name: null, searchLabel: null, sortLabel: null, isDesc: false, style: null},
					{ name: null, searchLabel: null, sortLabel: null, isDesc: false, hasSearch: false,  style: null},
					{ name: null, searchLabel: null, sortLabel: null, isDesc: false, style: null}
				];
			} else {
				this.theads = [
					{ name: 'Notification Image', searchLabel: null, sortLabel: null, isDesc: false, hasSearch: false, style: null},
					{ name: 'Notification Title', searchLabel: 'f_title', sortLabel: 'title', isDesc: false, hasSearch: true, style: null},
					{ name: 'Notification Link', searchLabel: 'f_link', sortLabel: 'link', isDesc: false, hasSearch: true, style: null},
					{ name: 'Scheduled Type', searchLabel: 'f_scheduleType', isDesc: false, style: null, hasScheduleTypeList: true},
					{ name: 'Scheduled Age', searchLabel: 'f_ageInMonths', sortLabel: 'ageInMonths', isDesc: false, style: null, hasSearchAge: true},
					{ name: 'Recipients', searchLabel: null, sortLabel: null, isDesc: false, style: 'min-width: 120px'},
					{ name: null, searchLabel: null, sortLabel: null, isDesc: false, style: null},
					{ name: null, searchLabel: null, sortLabel: null, isDesc: false, hasSearch: false,  style: null},
					{ name: null, searchLabel: null, sortLabel: null, isDesc: false, style: null}
				];
			}
		}
	},
	created() {
		this.getTableContent(false);
	},
	activated() {
        // this lifecycle method will only be called for components under keep-alive
        this.getTableContent();
	},
	methods: {
		getTableContent(fromFilter, page = this.page, limit = this.limit, sortBy = this.sortBy, desc = this.desc) {
			page = fromFilter ? 1 : this.page;
			this.getNotificationList({ page, limit, sortBy, desc });
		},
		getNotificationList(queryParams) {
			this.isAPILoading = true;

			// date or age filter
			if (this.selectedScheduleType === `DATE_BASE` && this.selectedDateTime) {
				queryParams['f_schedule'] = this.formatDate(this.selectedDateTime, 'yyyy-MM-dd');
			} else if (this.columnsFilter.f_ageInMonths){
				queryParams['f_ageInMonths'] = this.columnsFilter.f_ageInMonths;
			}
			
			// search filters
			if (this.columnsFilter) {
				if (this.columnsFilter.f_title) {
					queryParams['f_title'] = this.columnsFilter.f_title; 
				}
				if (this.columnsFilter.f_link) {
					queryParams['f_link'] = this.columnsFilter.f_link;
				}
			}

		  	queryParams['f_scheduleType'] = this.selectedScheduleType;

			NotificationService.getNotificationList(queryParams)
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.tableContent = {
							tableData: res.data.data,
							paginationData: res.data.pagination
						};
					} else {
						const { ERROR_GET_NOTIFICATION_LIST } = this.toastMessages.notification();
						this.showAPIErrorToast(ERROR_GET_NOTIFICATION_LIST, res);
					}
					this.isAPILoading = false;
				});
		},
		hasNotificationImage(notificationImage) {
			let image = require('@/assets/images/_shared/notification-dog.png');

			if (notificationImage) {
				image = notificationImage;
			}

			return image;
		},
		showCustomRecipients(notification) {
			if (notification.recipients.length > 1) {
				this.$refs.modalCustomRecipient.show(notification);
			}
		},
		checkIfMultipleRecipients(recipients, recipientGroup) {
			const recipientObj = recipients[0];
			let recipient = ''
			if (recipients.length > 1) {
				recipient = 'Multiple Recipients';
			} else {
				if (recipientObj) {
					if (recipientObj.name && recipientObj.name.trim().length > 0) {
						recipient = recipientObj.name
					} else {
						if (recipientGroup === 'CUSTOMER' || 
							recipientGroup === 'BREEDER') {
							const groupRecipient = recipientGroup.charAt(0).toUpperCase() + recipientGroup.slice(1).toLowerCase()
							recipient = `All (${groupRecipient})`;
						} else {
							recipient = 'All';
						}
						
					}
				} else {
					recipient = recipientGroup;
				}
			}
			return recipient;
		},
		showNotificationsBodyModal(notifications) {
			this.$refs.modalNotificationBody.show(notifications);
		},
		deleteNotification(id, title) {
			
			this.$swal({
				title: `Delete Notification`,
				text: `Are you sure you want to delete - ${title}?`,
				confirmButtonText: 'Confirm',
				showCancelButton: true,
				cancelButtonText: 'Cancel',
				reverseButtons: true,
				showCloseButton: true
			})
			.then(result => {
				if(result.value) {
					this.isAPILoading = true;

					NotificationService.deleteNotification(id)
					.then(res => {
						if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
							this.getTableContent(false);

							const { SUCCESS_DELETE_NOTIFICATION } = this.toastMessages.notification();
							this.showCustomSuccessToast(SUCCESS_DELETE_NOTIFICATION, '');
						} else {
							const { ERROR_DELETE_NOTIFICATION } = this.toastMessages.notification();
							this.showAPIErrorToast(ERROR_DELETE_NOTIFICATION, res);
						}
						this.isAPILoading = false;
					})
					.catch(err => {
						this.showGenericErrorToast();
						this.isAPILoading = false;
					});
				}
			})
		},
		formatSchedule(notification) {
			if (notification.scheduleType === 'AGE_BASE') {
				return `${notification.scheduleAge} months`
			} else if (notification.schedule === null) {
				return null
			} else {
				return this.formatDate(notification.scheduleDate);
			}
		}
	}
}